import { get, post } from "utils/request"
import store from "store"
import { AFF_BALANCE } from "store/ActionTypes"

export async function $getAffBalance() {
  const res = await get('/aff/balance', {})
  if (res.code === 0) {
    store.dispatch({ type: AFF_BALANCE, value: res.data })
  }
  return res
}

// 卡密兑换
export async function $cardmiExchange(cd_key: string, captcha: string) {
  const res = await post('/vip/cd-key', {
    body: {
      cd_key,
      captcha,
    }
  })
  return res
}
//折扣码查询
export async function $couponSearch(coupon_code: string, good_id: string) {
  const res = await post('/vip/coupon', {
    body: {
      coupon_code,
      good_id,
    }
  })
  return res
}
//获取连接
export async function $getLink( ) {
  const res = await get('/api/1/app/links', {})
  if (res.code === 0) {
    localStorage.setItem('links',JSON.stringify(res))
    
  }
  return res
}